module.exports = __webpack_public_path__ + "img/TITLE@3x.bed31631.png";